<template>
  <v-container class="pa-0 ma-0" id="mainhomecontainer">

    <v-card class="overview" elevation="24">

        <v-card-text class="mb-auto pa-0">

          <!-- <h2 class="py-2">Visitor Statistics</h2> -->

            <v-overlay v-model="overlay"
                    color= "#FE5800" >
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>


            <v-card-text class="mb-auto pa-0">
                <v-container fluid class="pb-0">
                <v-row>
                    <v-col cols="12" md="12" sm="12" class="business-name-top">
                    <h2>{{storeBusiness.businessName}}</h2>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12" class="pb-3 text-center  justify-center">
                        <span class="dashboard-title-2">{{$t('zz_real-time-data')}}</span><br><br>
                        <span class="pin-code">{{$t('zz_activity_report')}}</span><br>
                    </v-col>
                </v-row>
                <hr class="ma-0 pl-2 pr-2">
                <h2 class="text-center pt-2 pb-2">{{$t('zz_current_activity')}}</h2>

        <!-- START OF DATA            -->

                <hr>

                </v-container>

                <v-card-text>
                    <div class="container">
                        <v-row class="col-12">
                            <div class="col-md-4">
                                <div class="profile-card-6 bgb"><img src="https://data.whicdn.com/images/304556718/original.gif" class="img img-responsive">
                                    <div class="profile-name">{{uniquevisitorstoday}}<span style="font-weight: 300"></span><span class="stat-number-2"> &#8680; {{totalpagevisitstoday}}<br></span>
                                        {{$t('zz_visitor_today')}}
                                    </div>
                                    <div class="profile-position">
                                        <p>
                                            <br>{{$t('zz_visitor_unique')}} &#8680; {{$t('zz_visitor_total')}}<br><br>
                                            <span class="running-total">{{$t('zz_spend')}} {{(parseFloat (uniquevisitorstoday) * 0.025).toFixed(2)}}€<br>  </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="profile-card-6"><img src="https://i.pinimg.com/originals/de/3f/d4/de3fd4e31317d724040d50c8330af12f.gif" class="img img-responsive">
                                    <div class="profile-name">{{uniquevisitorsthisweek}}<span style="font-weight: 300"></span><span class="stat-number-2"> &#8680; {{totalpagevisitsthisweek}}<br></span>
                                        {{$t('zz_visitor_this_week')}}
                                    </div>
                                    <div class="profile-position">
                                        <p>
                                            <br>{{$t('zz_visitor_unique')}} &#8680; {{$t('zz_visitor_total')}}<br><br>
                                            <span class="running-total">{{$t('zz_spend')}} {{(parseFloat (uniquevisitorsthisweek) * 0.025).toFixed(2)}}€<br>  </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="profile-card-6"><img src="https://i.pinimg.com/originals/41/6d/e1/416de1f8e82a223ec259a27a274c65fe.gif" class="">
                                    <div class="profile-name">{{uniquevisitorsthismonth}}<span style="font-weight: 300"></span><span class="stat-number-2"> &#8680; {{totalpagevisitsthismonth}}<br></span>
                                        {{$t('zz_visitor_this_month')}}
                                    </div>
                                    <div class="profile-position">
                                        <p>
                                            <br>{{$t('zz_visitor_unique')}} &#8680; {{$t('zz_visitor_total')}}<br><br>
                                            <span class="running-total">{{$t('zz_spend')}} {{(parseFloat (uniquevisitorsthismonth) * 0.025).toFixed(2)}}€<br>  </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </v-row>


                        <v-row>
                            <v-container fluid class="mt-10 pb-0">
                                <v-cols cols="12" md="12">
                                    <hr class="ma-0 pl-2 pr-2">
                                        <h2 class="text-center pt-2 pb-2">{{$t('zz_invoices')}}</h2>
                                    <hr>
                                </v-cols>
                            </v-container>

                            <div class="col-md-12">

                                <v-data-table
                                dark
                                dense
                                :headers="headerstable"
                                :items="weakrecords"
                                :items-per-page="52"
                                :search="search"
                                class="elevation-12"
                                
                                >




                                </v-data-table>


                                <!-- <v-simple-table
                                                dark
                                                dense
                                                fixed-header
                                                height="25vh"
                                                >

                                    <thead>
                                        <tr>
                                            <th class="text-left">Week No.</th>
                                            
                                            <th class="text-left">From:</th>
                                            <th class="text-left">To:</th>
                                            <th class="text-left">UDU</th>
                                            <th class="text-left">Views</th>
                                            <th class="text-left">Rate</th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(weekrecord,ind) in weakrecords" :key="ind">

                                            <td>{{weekrecord.weeknumber}}</td>
                                            
                                            <td>{{weekrecord.firstdayofweek}}</td>
                                            <td>{{weekrecord.lastdayofweek}}</td>
                                            <td>{{weekrecord.uniquevisitors}}</td>
                                            <td>{{weekrecord.totalvisitors}}</td>
                                            <td>{{weekrecord.userrate}}</td>


                                        </tr>

                                    </tbody>

                                </v-simple-table> -->
                            </div>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card-text>

<!-- TODAY          -->
        <v-row class="pl-2 pr-2">
            <!-- <v-col cols="12" md="4" class="">
                <v-card class="todayscard">
                    <v-card-text class="text-center justify-center">
                        <strong>UNIQUE CUSTOMERS TODAY </strong><br>
                        <span color="primary" class="display-1">{{uniquevisitorstoday}}</span>
                        <br>
                        <span>TOTAL PAGE VIEWS TODAY<br>
                        {{totalpagevisitstoday}}</span>
                        <br><br>
                        <v-card>
                            <v-card-text class="text-center justify-center">


                                <span>PIN {{totalpagevisitstodaypin}}</span> |

                                <span>NFC {{totalpagevisitstodaynfc}}</span> |

                                <span>QRC {{totalpagevisitstodayqr}}</span>

                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col> -->

<!-- THIS WEEK  -->

            <!-- <v-col cols="12" md="4">
                <v-card  class="thisweekscard">
                    <v-card-text class="text-center justify-center">
                        <strong>UNIQUE CUSTOMERS THIS WEEK</strong><br>
                        <span color="primary" class="display-1">{{uniquevisitorsthisweek}}</span>
                        <br>
                        <strong>UNIQUE CUSTOMERS LAST WEEK</strong><br>
                        <span color="primary" class="display-1">{{uniquevisitorslastweek}}</span>
                        <br>
                        <span>TOTAL VIEWS THIS WEEK {{totalpagevisitsthisweek}}<br>
                        TOTAL VIEWS LAST WEEK {{totalpagevisitslastweek}}</span>
                        <br><br>
                        <v-card>
                            <v-card-text class="text-center justify-center">


                                <span>PIN {{totalpagevisitsthisweekpin}}/{{totalpagevisitslastweekpin}}</span> |

                                <span>NFC {{totalpagevisitsthisweeknfc}}/{{totalpagevisitslastweeknfc}}</span> |

                                <span>QRC {{totalpagevisitsthisweekqr}}/{{totalpagevisitslastweekqr}}</span>

                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col> -->

<!-- THIS MONTH  -->

            <!-- <v-col cols="12" md="4">
                <v-card  class="thismonthscard">
                    <v-card-text class="text-center justify-center">
                        <strong>UNIQUE CUSTOMERS THIS MONTH</strong><br>
                        <span color="primary" class="display-1">{{uniquevisitorsthismonth}}</span>
                        <br>
                        <strong>UNIQUE CUSTOMERS LAST MONTH</strong><br>
                        <span color="primary" class="display-1">{{uniquevisitorslastmonth}}</span>
                        <br>
                        <span>TOTAL VIEWS THIS MONTH {{totalpagevisitsthismonth}}<br>
                        TOTAL VIEWS LAST MONTH {{totalpagevisitslastmonth}}</span>
                        <br><br>
                        <v-card>
                            <v-card-text class="text-center justify-center">


                                <span>PIN {{totalpagevisitsthismonthpin}}/{{totalpagevisitslastmonthpin}}</span> |

                                <span>NFC {{totalpagevisitsthismonthnfc}}/{{totalpagevisitslastmonthnfc}}</span> |

                                <span>QRC {{totalpagevisitsthismonthqr}}/{{totalpagevisitslastmonthqr}}</span>

                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-col> -->
        </v-row>
            </v-card-text>
        </v-card-text>
    </v-card>

    <!--<v-card class="overview" elevation="0">

        <v-card-text class="mb-auto pa-0">
          <h2 class="py-2">All Visitor Statistics</h2>

        </v-card-text>

        <v-card-text class="mb-auto pa-0">

            <form id="staticsform"  autocomplete="off" @submit.prevent="">


                <v-row>
                    <v-col cols="4" md="4" class="text-center pb-0">

                        <v-menu
                        no-title=true
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                            <template v-slot:activator="{ on }">

                            <v-text-field
                                v-model="computedDateFormatted"
                                label="From Date"
                                prepend-icon="event"
                                hint="DD/MM/YYYY"
                                persistent-hint
                                readonly
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker no-title v-model="fromdate" name="fromdate"  @input="menu2 = false"></v-date-picker>
                        </v-menu>

                    </v-col>

                    <v-col cols="4" md="4" class="text-center pb-0">
                        <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                                        transition="scale-transition" offset-y min-width="290px">
                                        <template v-slot:activator="{ on }">

                                        <v-text-field
                                            v-model="computedDateFormattedEnd"
                                            label="Event End Date"
                                            prepend-icon="event"
                                            hint="DD/MM/YYYY"
                                            persistent-hint
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                        </template>
                                        <v-date-picker no-title v-model="enddate" name="enddate"  @input="menu3 = false"></v-date-picker>
                                    </v-menu>
                    </v-col>

                    <v-col cols="4" md="4" class="text-center pb-0">
                        <v-btn class="primary" @click="submit">Submit</v-btn>

                    </v-col>
                </v-row>

            </form>

        </v-card-text>

         <v-card-text>
                <v-divider></v-divider>
                <v-data-table
                    :headers="headers"
                    :items="allbusinesstaganalitics"
                    :items-per-page="20"
                    :search="search"
                    class="elevation-1">





                </v-data-table>
            </v-card-text>

    </v-card>-->


  </v-container>
</template>

<script>
    

    



    import Vue from "vue";
    import moment from "moment";
    export default
    {
        props: {
            source: String
        },

        data: vm => ({

            overlay:false,

            headerstable: 
            [
                { text: "Wk No.", value: "weeknumber" },
                { text: "From", value: "firstdayofweek" },
                { text: "To", value: "lastdayofweek" },
                { text: "UWU", align: 'center', value: "uniquevisitors" },
                { text: "Views", align: 'right', value: "totalvisitors" },
                { text: "Spend", align: 'right', value: "userrate" },
            ],
            // [
            //     { text: "this.$t('zz_week_number')", value: "weeknumber" },
            //     { text: "$t('zz_from_date')", value: "firstdayofweek" },
            //     { text: "$t('zz_to_date')", value: "lastdayofweek" },
            //     { text: "$t('zz_unique_daily_users_abr')", align: 'right', value: "uniquevisitors" },
            //     { text: "$t('zz_views')", align: 'right', value: "totalvisitors" },
            //     { text: "$t('zz_spend')", align: 'right', value: "userrate" },
            // ],

           
            
            headers: [

                { text: "User ip", value: "userip" },
                { text: "Code", value: "code" },
                { text: "Source", value: "source" },
                { text: "Created At", value: "created_at" },

            ],

            weakrecords:[],
            storeBusiness: [],
            fromdate: new Date().toISOString().substr(0, 10),
            enddate: new Date().toISOString().substr(0, 10),
            dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
            menu3: false,
            menu2: false,
            allbusinesstaganalitics: [],

            uniquevisitorstoday:0,
            uniquevisitorsthismonth:0,
            uniquevisitorsthisweek:0,
            uniquevisitorslastmonth:0,
            uniquevisitorslastweek:0,

            totalpagevisitstoday:0,
            totalpagevisitstodaypin:0,
            totalpagevisitstodayqr:0,
            totalpagevisitstodaynfc:0,

            totalpagevisitsthisweek:0,
            totalpagevisitsthisweekpin:0,
            totalpagevisitsthisweeknfc:0,
            totalpagevisitsthisweekqr:0,

            totalpagevisitslastweek:0,
            totalpagevisitslastweekpin:0,
            totalpagevisitslastweeknfc:0,
            totalpagevisitslastweekqr:0,

            totalpagevisitsthismonth:0,
            totalpagevisitsthismonthpin:0,
            totalpagevisitsthismonthnfc:0,
            totalpagevisitsthismonthqr:0,

            totalpagevisitslastmonth:0,
            totalpagevisitslastmonthpin:0,
            totalpagevisitslastmonthnfc:0,
            totalpagevisitslastmonthqr:0,


        }),
        computed:
        {
            computedDateFormatted () {
                return this.formatDate(this.fromdate)
            },

            computedDateFormattedEnd(){
                return this.formatDate(this.enddate)
            },

        },
        watch:
        {
            fromdate(val) {
                this.dateFormatted = this.formatDate(this.fromdate)
            },
            enddate(val)
            {
                this.dateFormatted = this.formatDate(this.enddate)
            }
        },

        created()
        {
            this.storeBusiness = JSON.parse(localStorage.getItem("business"));

            this.visitordata();
            this.weakdata();
            setInterval(function(){this.visitordata},30000);

        },
        methods:{
            weakdata()
            {
                this.$http
                .get(
                    this.$apidomain+"weakrecord/" +
                    this.storeBusiness.id
                )
                .then(res => {
                    if (res.data.success)
                    {
                        this.weakrecords=res.data.weakdatas;

                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
            },
  
            visitordata()
            {

                this.$http
                .get(
                    this.$apidomain+"visitors/" +
                    this.storeBusiness.id
                )
                .then(res => {
                    if (res.data.success)
                    {
                    this.uniquevisitorstoday = res.data.uniquevisitorstoday;
                    this.uniquevisitorsthisweek = res.data.uniquevisitorsthisweek;
                    this.uniquevisitorslastweek = res.data.uniquevisitorslastweek;
                    this.uniquevisitorsthismonth = res.data.uniquevisitorsthismonth;
                    this.uniquevisitorslastmonth = res.data.uniquevisitorslastmonth;


                    this.totalpagevisitstoday=res.data.totalpagevisitstoday;
                    this.totalpagevisitstodaypin=res.data.totalpagevisitstodaypin;
                    this.totalpagevisitstodaynfc=res.data.totalpagevisitstodaynfc;
                    this.totalpagevisitstodayqr=res.data.totalpagevisitstodayqr;

                    this.totalpagevisitsthisweek=res.data.totalpagevisitsthisweek;
                    this.totalpagevisitsthisweekpin=res.data.totalpagevisitsthisweekpin;
                    this.totalpagevisitsthisweeknfc=res.data.totalpagevisitsthisweeknfc;
                    this.totalpagevisitsthisweekqr=res.data.totalpagevisitsthisweekqr;

                    this.totalpagevisitslastweek=res.data.totalpagevisitslastweek;
                    this.totalpagevisitslastweekpin=res.data.totalpagevisitslastweekpin;
                    this.totalpagevisitslastweeknfc=res.data.totalpagevisitslastweeknfc;
                    this.totalpagevisitslastweekqr=res.data.totalpagevisitslastweekqr;

                    this.totalpagevisitsthismonth=res.data.totalpagevisitsthismonth;
                    this.totalpagevisitsthismonthpin=res.data.totalpagevisitsthismonthpin;
                    this.totalpagevisitsthismonthnfc=res.data.totalpagevisitsthismonthnfc;
                    this.totalpagevisitsthismonthqr=res.data.totalpagevisitsthismonthqr;

                    this.totalpagevisitslastmonth=res.data.totalpagevisitslastmonth;
                    this.totalpagevisitslastmonthpin=res.data.totalpagevisitslastmonthpin;
                    this.totalpagevisitslastmonthnfc=res.data.totalpagevisitslastmonthnfc;
                    this.totalpagevisitslastmonthqr=res.data.totalpagevisitslastmonthqr;

                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
            },

            formatDate(date)
            {
                    if (!date) return null

                    const [year,month,day ] = date.split('-')
                    return `${day}/${month}/${year}`
            },
            submit()
            {

                let th = this;

                let fd = new FormData(document.getElementById("staticsform"));
                fd.append('fromdate',this.fromdate);
                fd.append('enddate',this.enddate);

                this.overlay=true;

                this.$http
                .post(
                    this.$apidomain+"staticsvisitors" ,fd)
                .then(res => {
                    if (res.data.success==1)
                    {
                        //alert(res.data.allbusinesstaganalitics);

                        this.allbusinesstaganalitics=res.data.allbusinesstaganalitics;

                        this.overlay=false;


                    }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;

                });

            }
        }
    }







</script>
<style scoped>

.todayscard{
background-color: #e9723d;

}

.thisweekscard{
background-color: #297fab;
}

.thismonthscard{
background-color: #f4d75f;
}

.dashboard-title{
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: #fe5800;
}

.dashboard-title-2{
  font-size: 14px;
  font-weight: 200;
  text-align: center;
  color: #1b1b1b;
  padding-top: 15px;
  padding-bottom: 15px;
}

.business-name-top{
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  color: #252525;
  padding-bottom: 10px;
}

.pin-code{
  font-size: 30px;
  font-weight: 800;
  color:#fe5800;
  padding-bottom: 15px;
  padding-top: 15px;
}

.dashboard-buttons{
  max-width: 300px !important;
  align-content: center;
  justify-content: center;
}


    /* =============CODEPEN CSS=================== */

.container-fluid,
.container {
    max-width: 1200px;
}

.card-container {
    padding: 100px 0px;
    -webkit-perspective: 1000;
    perspective: 1000;
}

.profile-card-1 {
    background-color: #FFF;
    border-radius: 10px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    /* background-image: url(../img/profile-bg-1.jpg); */
    background-position: center;
    padding-top: 100px;
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    max-width: 300px;
}

.profile-card-1 .profile-content {
    position: relative;
    background-color: #FFF;
    padding: 70px 20px 20px 20px;
    text-align: center;
}

.profile-card-1 .profile-img {
    position: absolute;
    height: 100px;
    left: 0px;
    right: 0px;
    z-index: 10;
    top: -50px;
    transition: all 0.25s linear;
    transform-style: preserve-3d;
}

.profile-card-1 .profile-img img {
    height: 100px;
    margin: auto;
    border-radius: 50%;
    border: 5px solid #FFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.profile-card-1 .profile-name {
    font-size: 18px;
    font-weight: bold;
    color: #021830;
}

.profile-card-1 .profile-address {
    color: #777;
    font-size: 12px;
    margin: 0px 0px 15px 0px;
}

.profile-card-1 .profile-description {
    font-size: 13px;
    padding: 5px 10px;
    color: #777;
}

.profile-card-1 .profile-icons .fa {
    margin: 5px;
    color: #777;
}

.profile-card-1:hover {
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
}

.profile-card-1:hover .profile-img {
    transform: rotateY(180deg);
}

.profile-card-2 {
    max-width: 300px;
    background-color: #FFF;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    background-position: center;
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    border-radius: 10px;
}

.profile-card-2 img {
    transition: all linear 0.25s;
}

.profile-card-2 .profile-name {
    position: absolute;
    left: 30px;
    bottom: 70px;
    font-size: 30px;
    color: #FFF;
    text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
    font-weight: bold;
    transition: all linear 0.25s;
}

.profile-card-2 .profile-icons {
    position: absolute;
    bottom: 30px;
    right: 30px;
    color: #FFF;
    transition: all linear 0.25s;
}

.profile-card-2 .profile-username {
    position: absolute;
    bottom: 50px;
    left: 30px;
    color: #FFF;
    font-size: 13px;
    transition: all linear 0.25s;
}

.profile-card-2 .profile-icons .fa {
    margin: 5px;
}

.profile-card-2:hover img {
    filter: grayscale(100%);
}

.profile-card-2:hover .profile-name {
    bottom: 80px;
}

.profile-card-2:hover .profile-username {
    bottom: 60px;
}

.profile-card-2:hover .profile-icons {
    right: 40px;
}

.profile-card-3 {
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 25px 15px;
}

.profile-card-3 .profile-name {
    font-weight: bold;
    color: #21304e;
}

.profile-card-3 .profile-location {
    color: #999;
    font-size: 13px;
    font-weight: 600;
}

.profile-card-3 img {
    height: 100px;
    width: 100px;
    object-fit: cover;
    margin: 10px auto;
    border-radius: 50%;
    transition: all linear 0.25s;
}

.profile-card-3 .profile-description {
    font-size: 13px;
    color: #777;
    padding: 10px;
}

.profile-card-3 .profile-icons {
    margin: 15px 0px;
}

.profile-card-3 .profile-icons .fa {
    color: #fe455a;
    margin: 0px 5px;
}

.profile-card-3:hover img {
    height: 110px;
    width: 110px;
    margin: 5px auto;
}

.profile-card-4 {
    max-width: 300px;
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
}

.profile-card-4 img {
    transition: all 0.25s linear;
}

.profile-card-4 .profile-content {
    position: relative;
    padding: 15px;
    background-color: #FFF;
}

.profile-card-4 .profile-name {
    font-weight: bold;
    position: absolute;
    left: 0px;
    right: 0px;
    top: -70px;
    color: #FFF;
    font-size: 17px;
}

.profile-card-4 .profile-name p {
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 1.5px;
}

.profile-card-4 .profile-description {
    color: #777;
    font-size: 12px;
    padding: 10px;
}

.profile-card-4 .profile-overview {
    padding: 15px 0px;
}

.profile-card-4 .profile-overview p {
    font-size: 10px;
    font-weight: 600;
    color: #777;
}

.profile-card-4 .profile-overview h4 {
    color: #273751;
    font-weight: bold;
}

.profile-card-4 .profile-content::before {
    content: "";
    position: absolute;
    height: 20px;
    top: -10px;
    left: 0px;
    right: 0px;
    background-color: #FFF;
    z-index: 0;
    transform: skewY(3deg);
}

.profile-card-4:hover img {
    transform: rotate(5deg) scale(1.1, 1.1);
    filter: brightness(110%);
}

.profile-card-5 {
    max-width: 300px;
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 50px 15px 25px 15px;
}

.profile-card-5 img {
    height: 100px;
    width: 100px;
    object-fit: cover;
    margin: 10px auto;
    border-radius: 50%;
    transition: all linear 0.25s;
    position: relative;
}

.profile-card-5::before {
    content: "";
    position: absolute;
    top: -60px;
    right: 0px;
    left: 0px;
    height: 170px;
    background-color: #4fb96e;
    transform: skewY(-20deg);
}

.profile-card-5 .profile-name {
    padding-top: 15px;
    font-weight: bold;
    color: #333;
}

.profile-card-5 .profile-designation {
    font-size: 13px;
    color: #777;
}

.profile-card-3 .profile-location {
    color: #999;
    font-size: 13px;
    font-weight: 600;
}

.profile-card-5 .profile-description {
    font-size: 13px;
    color: #777;
    padding: 10px;
}

.profile-card-5 .profile-overview {
    padding: 15px 0px;
}

.profile-card-5 .profile-overview p {
    color: #777;
    font-size: 13px;
}

.profile-card-5 .profile-overview h2 {
    font-weight: bold;
    color: #1e2832;
}

.profile-card-5 .profile-icons .fa {
    margin: 7px;
    color: #4fb96e;
}

.profile-card-5:hover img {
    transform: rotate(-5deg);
}

.profile-card-6 {
    max-width: 400px;
    max-height: 200px;
    background-color: #FFF;
    border-radius: 10px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
}

.profile-card-6 img {
    transition: all 0.15s linear;
}

.profile-card-6 .lh-1{
    line-height: 1;
}

.profile-card-6 .profile-name {
    position: absolute;
    border-radius: 10px;
    top: 10px;
    left: 10px;
    right: 35px;
    font-size: 50px;
    font-weight: 800;
    line-height: 1;
    color: #FFF;
    padding: 15px 20px;
    background: linear-gradient(150deg, rgba(241, 6, 6, 0.75) 50%, rgba(253, 101, 0, 0) 50%);
    transition: all 0.15s linear;
}


.profile-card-6 .profile-position {
    position: absolute;
    color: rgb(255, 255, 255);
    left: 30px;
    top: 100px;
    transition: all 1.15s linear;
}

.profile-card-6 .profile-overview {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 50%, rgba(255, 255, 0, 0));
    color: #FFF;
    padding: 50px 0px 20px 0px;
    transition: all 0.15s linear;
}

.profile-card-6 .profile-overview h3 {
    font-weight: bold;
}

.profile-card-6 .profile-overview p {
    color: rgb(255, 255, 255);
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 10px;
}

.profile-card-6 .stat-number{
    color: #fff;
    font-size: 20px;
    font-weight: 800;
    padding: 20px;
}

.profile-card-6 .stat-number-2{
    color: #fff;
    font-size: 25px;
    font-weight: 600;

}

.profile-card-6 .running-total{
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    justify-content: flex-end;
    padding-bottom: 20px;

}


.profile-card-6 .stat-label{
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
}

.profile-card-6:hover img {
    filter: brightness(80%);
}

.profile-card-6:hover .profile-name {
    padding-left: 25px;
    padding-top: 20px;
}

.profile-card-6:hover .profile-position {
    left: 40px;
}

.profile-card-6:hover .profile-overview {
    padding-bottom: 25px;
}

.profile-card-7 {
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
}

.profile-card-7 .profile-content {
    padding: 60px 30px 30px 30px;
    background-color: #FFF;
    position: relative;
}

.profile-card-7 .profile-content img {
    position: absolute;
    height: 80px;
    width: 80px;
    border-radius: 50%;
    top: -40px;
    border: 5px solid #FFF;
}

.profile-card-7 .profile-content .profile-name {
    position: absolute;
    font-size: 17px;
    font-weight: bold;
    top: -35px;
    left: 125px;
    color: #FFF;
}

.profile-card-7 .profile-overview {
    padding: 5px 0px;
}

.profile-card-7 .profile-overview p {
    color: #777;
    font-size: 11px;
    font-weight: 600;
}

.profile-card-7 .profile-overview h5 {
    color: #142437;
    font-weight: bold;
}

.profile-card-8 {
    background: linear-gradient(#09121c, #36445a);
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    transition: all 0.25s linear;
}

.profile-card-8 .profile-name {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 25px;
    color: #58d683;
    font-size: 17px;
    font-weight: bold;
}

.profile-card-8 .profile-designation {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 50px;
    color: #FFF;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
}

.profile-card-8 .profile-icons {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 80px;
    color: rgba(255, 255, 255, 0.7);
}

.profile-card-8 .profile-icons .fa {
    margin: 5px;
}

.profile-card-8:hover {
    transform: scale(1.05, 1.05);
}

.profile-card-9 {
    border-radius: 10px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 30px 15px;
    background-color: #FFF;
    transition: all 0.25s linear;
}

.profile-card-9 img {
    height: 120px;
    width: 120px;
    border-radius: 50%;
    margin: 10px auto;
}

.profile-card-9 .profile-name {
    font-size: 15px;
    color: #3249b9;
    font-weight: 600;
}

.profile-card-9 .profile-designation {
    font-size: 13px;
    color: #777;
}

.profile-card-9 .profile-description {
    padding: 10px;
    font-size: 13px;
    color: #777;
    margin: 15px 0px;
    background-color: #F1F2F3;
    border-radius: 5px;
}

.profile-card-9 a {
    padding: 10px 15px;
    background-color: #3249b9;
    color: #FFF;
    font-size: 11px;
    border-radius: 25px;
}

.profile-card-9:hover {
    transform: scale(1.05, 1.05);
}

.profile-card-10 {
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 30px 15px;
    background-color: #1f2124;
    color: #EEE;
}

.profile-card-10 img {
    margin: 10px auto;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 10px solid transparent;
    box-shadow: 0px 0px 0px 2px #64c17b;
    transition: all 0.25s linear;
}

.profile-card-10 .profile-name {
    color: #FFF;
    font-weight: bold;
    font-size: 17px;
}

.profile-card-10 .profile-location {
    font-size: 13px;
    opacity: 0.7;
}

.profile-card-10 .profile-description {
    padding: 10px;
    font-size: 13px;
}

.profile-card-10 .profile-icons .fa {
    color: #ffc75e;
    margin: 10px;
}

.profile-card-10:hover img {
    transform: scale(1.1);
}





</style>
